<div class="content-container min-height m-t-20" *ngIf="personNotFound">
  <div class="spacer">
  </div>
  <wsd-not-found-page></wsd-not-found-page>
</div>
<div class="content-container min-height m-t-20" *ngIf="person">
  <div class="spacer">
    <a class="detail-back-button" (click)="goBack()">
      {{ 'WS_DIRECTORY.ORG_MODIFY.BACK_BUTTON' | translate }}
    </a>
  </div>
  <div class="ui-g">

    <div class="ui-g-12">
      <div class="main-topic-panel wsd-item-detail">
        <h3 class="show-on-mobile m-t-10"
            *gsShowIfHasPermission="['TITLE_READ', 'FIRST_NAME_READ', 'INITIALS_READ', 'MIDDLE_NAME_READ', 'LAST_NAME_READ', 'SUFFIX_READ', 'HONOURS_READ']">
          {{ getFullName() }}
        </h3>
        <div class="ui-g">
          <div class="ui-g-8">
            <h3 class="show-on-desktop"
                *gsShowIfHasPermission="['TITLE_READ', 'FIRST_NAME_READ', 'INITIALS_READ', 'MIDDLE_NAME_READ', 'LAST_NAME_READ', 'SUFFIX_READ', 'HONOURS_READ']">
              {{ getFullName() }}
            </h3>
            <div *gsShowIfHasPermission="['APPOINTMENTS_INCL_DIRECTORY_TITLES_READ']">
              <div *ngIf="person.appointments" class="person-appointments">
                <div *ngFor="let appointment of person.appointments" class="appointment">
                  <div class="appointment-texts">
                    <div class="appointment-information">
                      <span class="appointment-title">
                      {{appointment.directoryTitle ||
                      appointment.standardTitle?.name}}
                      </span>
                      <a [routerLink]="['/organizations', appointment.organization?.id, 'detail']"
                         class="appointment-organization">
                        {{appointment.organization?.name || '???'}}
                      </a> <span class="appointment-email" *ngIf="showContact(appointment?.email)">{{appointment.email}}</span>
                    </div>
                  </div>
                  <div class="appointment-download" *gsShowIfHasPermission="['VOLUNTEER_BUSINESS_CARD_READ']">
                    <a *ngIf="appointment.businessCardVisible"
                       (click)="display[appointment.id] = !display[appointment.id]"
                       class="fa fa-address-card"></a>

                    <p-dialog *ngIf="appointment.businessCardVisible"
                              header="{{ 'WS_DIRECTORY.PERSON_DETAIL.BUSINESS_CARD_DIALOG_TITLE' | translate }}"
                              [(visible)]="display[appointment.id]"
                              class="text-left">
                      <button pButton type="button"
                              [label]="'WS_DIRECTORY.PERSON_DETAIL.FULL_CARD' | translate"
                              (click)="exportCard('full-card', person.id, appointment.id)">
                      </button>
                      <button pButton type="button"
                              [label]="'WS_DIRECTORY.PERSON_DETAIL.CARD' | translate"
                              (click)="exportCard('card', person.id, appointment.id)">
                      </button>
                    </p-dialog>
                  </div>
                </div>
              </div>
            </div>

            <div *gsShowIfHasPermission="['CONTACTS_PERSON_READ']">
              <h4 class="m-t-30 m-b-15">CONTACT</h4>
              <ng-container *ngFor="let contact of person.contacts">
                <div *ngIf="showContact(contact)">
                  <label class="inline">{{ 'CONTACT_TYPES.' + contact.type | translate }}:</label> {{contact.value}}
                </div>
              </ng-container>

              <div *ngIf="!isSomeVisibleContacts && person?.organizationEmail">
                <label class="inline">{{ 'CONTACT_TYPES.EMAIL' | translate }}:</label> {{person?.organizationEmail}}
              </div>
            </div>

            <div *ngIf="!person.visibleContacts">
              {{ 'INFO_CONTACT.MESSAGE' | translate }}
            </div>

            <div class="ui-g show-on-mobile">
              <div class="ui-g-4 ui-sm-12" *gsShowIfHasPermission="['(SCOUT_ORG_USER)_LANGUAGE_READ']">
                <h4>LANGUAGES</h4>
                <ul>
                  <li *ngFor="let language of person.languages">
                    {{ language.name }}
                  </li>
                </ul>
                <span *ngIf="!person.languages.length">
                  {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
                </span>
              </div>

              <div class="ui-sm-12 show-on-mobile" *gsShowIfHasPermission="['ROLES_READ']">
                <h4>ROLES</h4>
                <ul>
                  <li *ngFor="let role of person.roles">
                    {{ role.name }}
                  </li>
                </ul>
                <span *ngIf="!person.roles.length">
                  {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
                </span>
              </div>

              <div class="ui-sm-12" *gsShowIfHasPermission="['PORTFOLIO_AREAS_OF_EXPERTISE_READ']">
                <h4>AREAS OF EXPERTISE</h4>
                <ul>
                  <li *ngFor="let expertiseArea of person.expertiseAreas">
                    {{ expertiseArea.name }}
                  </li>
                </ul>
                <span *ngIf="!person.expertiseAreas.length">
                  {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
                </span>
              </div>
            </div>
          </div>

          <div class="ui-g-4"
               *gsShowIfHasPermission="['PROFILE_IMAGE_READ']">
            <div *ngIf="!imageSrc" class="image-holder">
              <img src="../../../assets/images/no_image.png" *ngIf="!person.profileImageURL" class="story-image-placeholder">
              <img [src]="person.profileImageURL" *ngIf="person.profileImageURL">
            </div>
            <div *ngIf="imageSrc" class="image-holder">
              <img [src]="imageSrc" *ngIf="imageSrc">
            </div>
            <button *ngIf="editable" pButton label="{{ 'WS_DIRECTORY.ORG_DETAIL.MODIFY_BUTTON' | translate}}"
                    [routerLink]="['/persons', person.id, 'modify']"
                    class="w-100 m-b-30">
            </button>
          </div>
        </div>

        <div class="ui-g show-on-desktop">
          <div class="ui-g-4 ui-sm-12"
               *gsShowIfHasPermission="['(SCOUT_ORG_USER)_LANGUAGE_READ']">
            <h4>LANGUAGES</h4>
            <ul>
              <li *ngFor="let language of person.languages">
                {{ language.name }}
              </li>
            </ul>
            <span *ngIf="!person.languages.length">
              {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
            </span>
          </div>

          <div class="ui-g-4 ui-sm-12" *gsShowIfHasPermission="['ROLES_READ']">
            <h4>ROLES</h4>
            <ul>
              <li *ngFor="let role of person.roles">
                {{ role.name }}
              </li>
            </ul>
            <span *ngIf="!person.roles.length">
              {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
            </span>
          </div>

          <div class="ui-g-4 ui-sm-12"
               *gsShowIfHasPermission="['PORTFOLIO_AREAS_OF_EXPERTISE_READ']">
            <h4>AREAS OF EXPERTISE</h4>
            <ul>
              <li *ngFor="let expertiseArea of person.expertiseAreas">
                {{ expertiseArea.name }}
              </li>
            </ul>
            <span *ngIf="!person.expertiseAreas.length">
              {{ 'WS_DIRECTORY.PERSON_DETAIL.NO_ENTRIES' | translate }}
            </span>
          </div>
        </div>

        <div class="ui-g"
             *gsShowIfHasPermission="['COMMENT_READ']">
          <div class="ui-g-12">
            <h4>COMMENTS</h4>
          </div>
          <div class="ui-g-12">{{ person.comment }}</div>

        </div>

        <div class="login-update">
          Last login: {{ formatDateToNow(person.lastLogin) }} &bull; Last update: {{
          formatDateToNow(person.lastModifiedDate) }}
        </div>

      </div>
    </div>

  </div>
</div>


<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>
